export default function (api: GlobalFetch) {
  return async function (id_room) {
    const response = await api.fetch(
      `/api/v2/airbnb/configuration/id_room/${id_room}`,
    )
    return await handleResponse(response)
  }
}

export async function handleResponse(response) {
  const json: IData = await response.json()
  return mapResponseToConfiguration(json.items)
}

const mapResponseToConfiguration = (item) => ({
  ...item,
  pricing: {
    ...item.pricing,
    price_per_extra_person: item.pricing.price_per_extra_person
      ? item.pricing.price_per_extra_person
      : null,
    //security_deposit: item.pricing.security_deposit
    //  ? item.pricing.security_deposit
    //  : null,
    cleaning_fee: item.pricing.cleaning_fee ? item.pricing.cleaning_fee : null,
  },
  availability: {
    ...item.availability,
    day_of_week_check_in: Array.from(new Array(7)).map((_, i) =>
      item.availability.day_of_week_check_in.includes(i) ? 0 : 1,
    ),
    day_of_week_check_out: Array.from(new Array(7)).map((_, i) =>
      item.availability.day_of_week_check_out.includes(i) ? 0 : 1,
    ),
  },
})

interface IData {
  messages: string[]
  items: IAirbnbConfiguration
}

export interface ListingApprovalStatus {
  status_category: string
  notes?: any
}

export interface SMOKEDETECTOR {
  instruction: string
  is_present: boolean
  metadata?: any
}

export interface DRYER {
  instruction: string
  is_present: boolean
  metadata?: any
}

export interface ESSENTIALS {
  instruction: string
  is_present: boolean
  metadata?: any
}

export interface Amenities {
  SMOKE_DETECTOR: SMOKEDETECTOR
  DRYER: DRYER
  ESSENTIALS: ESSENTIALS
}

export interface Listing {
  id: number
  name: string
  property_type_group: string
  property_type_category: string
  room_type_category: string
  bedrooms: number
  bathrooms: number
  beds: number
  amenity_categories: string[]
  check_in_option?: any
  listing_approval_status: ListingApprovalStatus
  has_availability: boolean
  permit_or_tax_id?: any
  apt: string
  street: string
  city: string
  state: string
  zipcode: string
  country_code: string
  lat: number
  lng: number
  user_defined_location: boolean
  directions: string
  person_capacity: number
  /*listing_currency: string
  listing_price: number*/
  synchronization_category: string
  bathroom_shared?: any
  bathroom_shared_with_category?: any
  common_spaces_shared?: any
  common_spaces_shared_with_category?: any
  total_inventory_count?: any
  property_external_id?: any
  listing_nickname?: any
  tier: string
  display_exact_location_to_guest: boolean
  house_manual?: any
  wifi_network?: any
  wifi_password?: any
  amenities: Amenities
  rate_plan_enabled?: any
  listing_views?: any
  id_str: string
}

export interface Pricing {
  cleaning_fee?: any
  default_daily_price: number
  eligible_for_pass_through_taxes: boolean
  guests_included: number
  listing_currency: string
  listing_id: number
  monthly_price_factor?: any
  price_per_extra_person: number
  /*security_deposit: number*/
  standard_fees: any[]
  pass_through_taxes: any[]
  pass_through_taxes_collection_type: string
  weekend_price?: any
  weekly_price_factor?: any
  default_pricing_rules: any[]
  listing_id_str: string
}

export interface BookingLeadTime {
  hours: number
  allow_request_to_book: number
}

export interface DayOfWeekMinNights {
  0: number
  1: number
  2: number
  3: number
  4: number
  5: number
  6: number
}

export interface MaxDaysNotice {
  days: number
}

export interface MaxDaysNoticeRule {
  days: number
  allow_rtb_beyond_max_days_notice?: boolean
}

export interface MinDaysNotice {
  days: number
}

export interface TurnoverDays {
  days: number
}

export interface Availability {
  listing_id: number
  booking_lead_time: BookingLeadTime
  day_of_week_check_in: number[]
  day_of_week_check_out: number[]
  day_of_week_min_nights: DayOfWeekMinNights
  default_max_nights: number
  default_min_nights: number
  max_days_notice: MaxDaysNotice
  max_days_notice_rule?: MaxDaysNoticeRule
  min_days_notice: MinDaysNotice
  turnover_days: TurnoverDays
  seasonal_min_nights?: any
  allow_rtb_above_max_nights: boolean
  listing_id_str: string
}

export interface IAirbnbConfiguration {
  listing: Listing
  pricing: Pricing
  availability: Availability
}
